define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/my-profile/myProfileDialogLayout.tmpl");
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");

    var that;

    var MyProfileDialogLayout = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        MyProfileDialogLayout = Marionette.Layout.extend({
            tagName: 'div',
            className: 'my-profile-dialog-container',
            template: template,

            regions: {
                myProfileRegion: '.my-profile-container'
            },


//            ui: {
//                btnSave: ".button-save",
//                btnCancel: ".button-cancel"
//            },

//            uiComponents: {
//                btnSave: {
//                    type: Button,
//                    options: {
//                        el: "view.ui.btnSave",
//                        permutation: Button.PERMUTATION.BTN_PRIMARY,
//                        onClick: save
//                    }
//                },
//                btnCancel: {
//                    type: Button,
//                    options: {
//                        el: "view.ui.btnCancel",
//                        permutation:Button.PERMUTATION.LINK
//                    },
//                    events: {
//                        "click": "_cancel"
//                    }
//                }
//            },

            onRender: function() {
                that = this;
            },

            onCancel: function(){
                that.trigger(MyProfileDialogLayout.TRIGGERING.CANCEL_BUTTON_CLICKED);
//                that.close();
            }

//            onBeforeClose: function() {
//                this.uiComponents.btnSave.close();
//                this.uiComponents.btnCancel.close();
//            }
        });

    });

    MyProfileDialogLayout.TRIGGERING = {
        CANCEL_BUTTON_CLICKED: "cancelButtonClicked"
    };

    return MyProfileDialogLayout;
});